import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_32aa2cdc-2128-46e1-b78d-17029247dee5/artifacts/q6wuaspw_ChatGPT%20Image%20Feb%203%2C%202026%2C%2006_33_23%20PM.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0a0a0a] text-white py-16 lg:py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={LOGO_URL}
                alt="Ultimate Caulking Co"
                className="h-16 w-16 object-contain invert"
              />
              <div>
                <h3 className="font-heading text-2xl font-bold">ULTIMATE CAULKING</h3>
                <p className="text-[#a3a3a3] text-sm">COMPANY</p>
              </div>
            </div>
            <p className="text-[#a3a3a3] leading-relaxed max-w-md mb-6">
              Professional caulking services for Adelaide and South Australia. 
              We specialize in residential sealing for bathrooms, kitchens, windows, and doors.
            </p>
            <div className="flex items-center gap-2 text-[#a3a3a3]">
              <MapPin className="w-4 h-4" />
              <span>Serving Adelaide & South Australia</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-6">QUICK LINKS</h4>
            <nav className="space-y-4">
              <a
                href="#services"
                onClick={(e) => scrollToSection(e, "#services")}
                className="block text-[#a3a3a3] hover:text-white transition-colors"
                data-testid="footer-services"
              >
                Services
              </a>
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, "#contact")}
                className="block text-[#a3a3a3] hover:text-white transition-colors"
                data-testid="footer-contact"
              >
                Contact
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-6">CONTACT US</h4>
            <div className="space-y-4">
              <a
                href="tel:0482909501"
                className="flex items-center gap-3 text-[#a3a3a3] hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5" />
                <span>0482 909 501</span>
              </a>
              <a
                href="mailto:hello@ultimatecaulking.co"
                className="flex items-center gap-3 text-[#a3a3a3] hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                <span>hello@ultimatecaulking.co</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#262626] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#a3a3a3] text-sm">
            © {currentYear} Ultimate Caulking Co. All rights reserved.
          </p>
          <p className="text-[#525252] text-sm">
            ABN: 12 345 678 901
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
